<template>

<div class="mbh-quiz" v-if="data">

	<div class="mbh-intro" v-if="data.intro && !started" v-html="data.intro"></div>

	<template v-if="!complete">

		<div class="mbh-quiz-progress">Question {{ currentIndex + 1 }} of {{ questions.length }}</div>

		<div class="mbh-quiz-question" v-if="currentQuestion">

			<div class="mbh-quiz-question-text">{{ currentQuestion.text }}</div>

			<div class="mbh-quiz-actions" v-if="!revealed">
				<button class="mbh-quiz-button" v-on:click="onAnswer(1)">True</button>
				<button class="mbh-quiz-button" v-on:click="onAnswer(0)">False</button>
			</div>

			<div class="mbh-quiz-result" v-if="revealed" :class="{'is-correct': isCorrect, 'is-incorrect': !isCorrect}">
				<div class="mbh-quiz-result-icon"><i class="fa-solid" :class="isCorrect ? 'fa-check' : 'fa-xmark'"></i></div>
				<div class="mbh-quiz-result-text" v-html="currentQuestion.explanation"></div>
			</div>

			<button class="mbh-quiz-next" v-if="revealed" v-on:click="onNext">{{ isLast ? 'See Results' : 'Next Question' }}</button>

		</div>

	</template>

	<template v-if="complete">

		<div class="mbh-quiz-complete">
			<div class="mbh-quiz-complete-score">{{ correctCount }} / {{ questions.length }}</div>
			<div class="mbh-quiz-complete-best" v-if="highScore > 0">Best: {{ highScore }} / {{ questions.length }}</div>
			<div class="mbh-quiz-complete-text" v-if="data.complete" v-html="data.complete"></div>
			<button class="mbh-quiz-next" v-on:click="onRetake">Take Again</button>
			<button class="mbh-quiz-review-button" v-on:click="openMyAnswers">View all my answers</button>
		</div>

	</template>

	<portal to="modal" v-if="showReview">

		<div class="health-modal">

			<div class="health-modal-overlay" v-on:click="closeReview"></div>

			<div class="health-modal-panel" style="max-width: 700px;">

				<div class="health-modal-header">
					<div class="health-modal-title">{{ reviewMine ? 'My answers' : 'All answers' }}</div>
					<button class="health-modal-close" v-on:click="closeReview">&times;</button>
				</div>

				<div class="health-modal-body" style="flex-direction: column; align-items: stretch;">

					<div class="mbh-quiz-review-item" v-for="(q, index) in questions" :key="q.id">

						<div class="mbh-quiz-review-q">{{ index + 1 }}. {{ q.text }}</div>

						<div class="mbh-quiz-review-mine" v-if="reviewMine && answers[q.id] !== undefined" :class="{'is-correct': answers[q.id] === q.answer, 'is-incorrect': answers[q.id] !== q.answer}">
							<i class="fa-solid" :class="answers[q.id] === q.answer ? 'fa-check' : 'fa-xmark'"></i> Your answer: {{ answers[q.id] ? 'True' : 'False' }}
						</div>

						<div class="mbh-quiz-review-correct">Correct answer: <strong>{{ q.answer ? 'True' : 'False' }}</strong></div>

						<div class="mbh-quiz-review-explanation" v-if="q.explanation" v-html="q.explanation"></div>

					</div>

				</div>

			</div>

		</div>

	</portal>

</div>

</template>

<script>

export default {

	props: ['data'],

	data: function() {

		return {
			currentIndex: 0,
			answers: {},
			revealed: false,
			complete: false,
			started: true,
			highScore: 0,
			showReview: false,
			reviewMine: false
		}

	},

	created: function() {

		var saved = localStorage.getItem('ifrap_patient_quiz')
		if (saved) {
			this.highScore = parseInt(saved)
			this.$emit('complete')
		}

	},

	computed: {

		questions: function() { return this.data.questions || [] },
		currentQuestion: function() { return this.questions[this.currentIndex] || null },
		isCorrect: function() { return this.currentQuestion && this.answers[this.currentQuestion.id] === this.currentQuestion.answer },
		isLast: function() { return this.currentIndex === this.questions.length - 1 },

		correctCount: function() {

			var self = this
			var count = 0
			this.$_.each(this.questions, function(q) { if (self.answers[q.id] === q.answer) count++ })
			return count

		}

	},

	methods: {

		onAnswer: function(value) {

			this.$set(this.answers, this.currentQuestion.id, value)
			this.revealed = true

		},

		onNext: function() {

			if (this.isLast) {
				this.complete = true
				this.$emit('complete')
				if (this.correctCount > this.highScore) {
					this.highScore = this.correctCount
					localStorage.setItem('ifrap_patient_quiz', this.highScore)
				}
			} else {
				this.currentIndex++
				this.revealed = false
			}

		},

		onRetake: function() {

			this.currentIndex = 0
			this.answers = {}
			this.revealed = false
			this.complete = false

		},

		openAnswers: function() {

			this.reviewMine = false
			this.showReview = true

		},

		openMyAnswers: function() {

			this.reviewMine = true
			this.showReview = true

		},

		closeReview: function() {

			this.showReview = false

		}

	}

}

</script>

<style>

.mbh-intro { font-size: 18px; color: #343434; line-height: 28px; margin-bottom: 24px; font-weight: 300; }
.mbh-quiz-progress { font-size: 14px; color: #888; text-transform: uppercase; letter-spacing: 1px; font-weight: 600; margin-bottom: 16px; }
.mbh-quiz-question { display: flex; flex-direction: column; }
.mbh-quiz-question-text { font-size: 24px; font-weight: 600; color: #343434; line-height: 32px; margin-bottom: 32px; }
.mbh-quiz-actions { display: flex; gap: 16px; }

.mbh-quiz-button {
	flex: 1; padding: 18px 32px; border-radius: 32px; font-size: 18px; font-weight: 700;
	border: 2px solid var(--aid-color); background-color: transparent; color: #343434; cursor: pointer;
	user-select: none;
}

.mbh-quiz-button:hover { background-color: var(--aid-color); color: #fff; }

.mbh-quiz-result { display: flex; align-items: center; padding: 24px; border-radius: 16px; margin-bottom: 24px; }
.mbh-quiz-result.is-correct { background-color: #e8f5e9; }
.mbh-quiz-result.is-incorrect { background-color: #fce4ec; }
.mbh-quiz-result-icon { width: 40px; height: 40px; flex-shrink: 0; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin-right: 16px; }
.mbh-quiz-result.is-correct .mbh-quiz-result-icon { background-color: #4CAF50; }
.mbh-quiz-result.is-incorrect .mbh-quiz-result-icon { background-color: #ee7173; }
.mbh-quiz-result-icon i { color: #fff; font-size: 18px; }
.mbh-quiz-result-text { font-size: 16px; color: #343434; line-height: 24px; font-weight: 600; flex: 1; }

.mbh-quiz-next {
	padding: 14px 40px; border-radius: 32px; font-size: 16px; font-weight: 600;
	background-color: var(--aid-color); color: #fff; border: none; cursor: pointer; align-self: center;
	margin: 0px auto;
    display: block;
}

.mbh-quiz-next:hover { filter: brightness(90%); }

.mbh-quiz-complete { text-align: center; }
.mbh-quiz-complete-score { font-size: 64px; font-weight: 700; color: #343434; margin-bottom: 8px; }
.mbh-quiz-complete-best { font-size: 14px; color: #888; font-weight: 600; margin-bottom: 16px; text-transform: uppercase; letter-spacing: 1px; }
.mbh-quiz-complete-text { font-size: 18px; color: #666; line-height: 28px; margin-bottom: 24px; }

.mbh-quiz-review-button {
	margin-top: 12px; padding: 14px 40px; border-radius: 32px; font-size: 16px; font-weight: 600;
	background-color: transparent; color: #343434; border: 2px solid var(--aid-color); cursor: pointer;
	display: block; margin-left: auto; margin-right: auto;
}
.mbh-quiz-review-button:hover { background-color: var(--aid-color); color: #fff; }

.mbh-quiz-review-item { padding: 16px 0; border-bottom: 1px solid #eee; }
.mbh-quiz-review-item:last-child { border-bottom: none; }
.mbh-quiz-review-q { font-size: 16px; font-weight: 600; color: #343434; line-height: 24px; margin-bottom: 8px; }
.mbh-quiz-review-correct { font-size: 15px; color: #343434; margin-bottom: 6px; }
.mbh-quiz-review-mine { font-size: 15px; font-weight: 600; margin-bottom: 6px; }
.mbh-quiz-review-mine.is-correct { color: #4CAF50; }
.mbh-quiz-review-mine.is-incorrect { color: #ee7173; }
.mbh-quiz-review-explanation { font-size: 14px; color: #666; line-height: 22px; }

</style>
